import React from 'react';

const viagensFake = [
  {
    id: 1,
    data: '15/07/2025',
    origem: 'Avenida Paulista, São Paulo',
    destino: 'Rua Augusta, São Paulo',
    distancia: '5 km',
    duracao: '15 min',
    valor: 'R$ 25,00',
    status: 'Concluída',
  },
  {
    id: 2,
    data: '10/07/2025',
    origem: 'Praça da Sé, São Paulo',
    destino: 'Parque Ibirapuera, São Paulo',
    distancia: '8 km',
    duracao: '25 min',
    valor: 'R$ 35,00',
    status: 'Cancelada',
  },
  // ... mais viagens
];

function Historico() {
  return (
    <div className="container my-4">
      <h2 className="mb-4">Histórico de Viagens</h2>

      {viagensFake.length === 0 ? (
        <p>Você ainda não realizou nenhuma viagem.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>Data</th>
                <th>Origem</th>
                <th>Destino</th>
                <th>Valor</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {viagensFake.map((viagem) => (
                <tr key={viagem.id}>
                  <td>{viagem.data}</td>
                  <td>{viagem.origem}</td>
                  <td>{viagem.destino}</td>
                  <td>{viagem.valor}</td>
                  <td>
                    <span
                      className={
                        viagem.status === 'Concluída'
                          ? 'badge bg-success'
                          : viagem.status === 'Cancelada'
                          ? 'badge bg-danger'
                          : 'badge bg-secondary'
                      }
                    >
                      {viagem.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Historico;
